import { createFileRoute } from '@tanstack/react-router'
import { ForgingsReportPage } from 'pages/forgingsReporting/ForgingsReportPage'

export const Route = createFileRoute('/forgings-reporting/$inspectionId')({
  component: RouteComponent,
  staticData: {
    layout: {
      enableScrolling: false,
      showSearchBar: false,
      useDynamicViewportHeight: true,
    },
  },
})

function RouteComponent() {
  const { inspectionId } = Route.useParams()
  const { orgId, siteId } = Route.useSearch()
  return (
    <ForgingsReportPage
      inspectionId={inspectionId}
      orgId={orgId}
      siteId={siteId}
    />
  )
}
